import { useCallback } from 'react';

import { useFormData } from '@sayyesschool/frontend/hooks/form';
import { Flex, Form } from '@sayyesschool/frontend/ui-components';

const getData = ({
    active = true,
    visits = 0,
    duration = [1, 'day'],
    price = 0,
    priceWithoutDiscount = 0
} = {}) => ({
    active,
    visits,
    duration: {
        value: duration[0],
        period: duration[1]
    },
    price,
    priceWithoutDiscount
});

export default function MembershipPackForm({
    pack,
    onSubmit,
    ...props
}) {
    const { data, handleChange } = useFormData(getData(pack), [pack?.id]);

    const handleSubmit = useCallback(() => {
        onSubmit({
            ...data,
            duration: [
                Number(data.duration.value),
                data.duration.period
            ],
            visits: Number(data.visits),
            price: Number(data.price),
            priceWithoutDiscount: Number(data.priceWithoutDiscount)
        });
    }, [data, onSubmit]);

    return (
        <Form
            id="membership-pack-form"
            onSubmit={handleSubmit}
            {...props}
        >
            {pack?.id &&
                <Form.Switch
                    label="Активный"
                    name="active"
                    checked={data.active}
                    onChange={handleChange}
                />
            }

            <Form.Field label="Длительность">
                <Flex gap="s">
                    <Form.Input
                        type="text"
                        name="duration.value"
                        value={data.duration.value}
                        min={0}
                        onChange={handleChange}
                    />

                    <Form.Select
                        name="duration.period"
                        value={data.duration.period}
                        options={[
                            {
                                content: 'день',
                                label: 'день',
                                value: 'day'
                            },
                            {
                                content: 'неделя',
                                label: 'неделя',
                                value: 'week'
                            },
                            {
                                content: 'месяц',
                                label: 'месяц',
                                value: 'month'
                            }
                        ]}
                        onChange={handleChange}
                    />
                </Flex>
            </Form.Field>

            <Form.Input
                type="number"
                name="visits"
                value={data.visits}
                label="Кол-во посещений"
                end="раз"
                min={0}
                onChange={handleChange}
            />

            <Form.Input
                type="number"
                name="price"
                value={data.price}
                label="Стоимость без скидки"
                end="руб."
                min={0}
                onChange={handleChange}
            />

            <Form.Input
                type="number"
                name="priceWithoutDiscount"
                value={data.priceWithoutDiscount}
                label="Стоимость со скидкой"
                end="руб."
                min={0}
                onChange={handleChange}
            />

        </Form>
    );
}

/**
 *  {
      "id": "21dec724-4a40-48ef-9cf7-89f0fb3c4d07",
      "duration": [
        2,
        "week"
      ],
      "price": 590,
      "priceWithoutDiscount": 590,
      "visits": 1
    },
 */